import React, { useState } from 'react';
import AdminDashboardNavbar from './AdminDashboardNavbar';
import AdminDashboardMenu from './AdminDashboardMenu';
import { useAuth } from '../../contexts/AuthContext';
import AdminQuestionSetup from './AdminQuestionSetup';
import AdminVideoSetup from './AdminVideoSetup';
import AdminUsersAnswers from './AdminUsersAnswers';
import AdminUsersAnswersAll from './AdminUsersAnswersAll';
import AdminUser from './AdminUser';
import AdminUsers from './AdminUsers';
import AdminNews from './AdminNews';
import AdminLoginLogs from './AdminLoginLogs';
import AdminMessagesToAdmin from './AdminMessagesToAdmin';
import AdminTestAgora from './AdminTestAgora';
import AdminRegisterLogs from './AdminRegisterLogs';

function AdminDashboardContent() {
    const [menuName, setMenuName] = useState("การเข้าใช้งาน");

    const { currentUser } = useAuth();

    function validateCurrentUser() {
        if (currentUser === null) return false;

        return currentUser.email === "charuwan_s@hotmail.com" || currentUser.email === "sermyot@gmail.com" || currentUser.email === 'charuwan@gmail.com' || currentUser.email === 'quick.birdiii@gmail.com';
    }

    const menuList = [ 
        { name: "คำถาม-คำตอบ", active: true }, 
        { name: "คำตอบของพนักงาน", active: true }, 
        { name: "คะแนนของพนักงานทุกคน", active: true }, 
        { name: "Video-Setup", active: true }, 
        { name: "ค้นหาผู้ใช้งาน", active: true }, 
        { name: "ผู้ใช้งานทั้งหมด", active: true }, 
        { name: "แจ้งข่าวสาร", active: true }, 
        { name: "การสมัคร", active: true }, 
        { name: "การเข้าใช้งาน", active: true }, 
        { name: "ข้อความถึงแอดมิน", active: true }, 
        { name: "User-Management", active: validateCurrentUser() }, 
        { name: "Test-Agora", active: validateCurrentUser() }, 
    ];

    function onClick(e) {
        setMenuName(e.target.id);
    }

    return (
        <div>
            <div className="AdminPageMainContainer">
                <AdminDashboardMenu onClick={onClick} menuName={menuName} menuList={menuList} />
                <div className='AdminContentArea'>
                {
                    menuName === "คำถาม-คำตอบ" ?
                        <AdminQuestionSetup />
                    :
                        menuName === "คำตอบของพนักงาน" ?
                            <AdminUsersAnswers />
                        :
                            menuName === "คะแนนของพนักงานทุกคน" ?
                                <AdminUsersAnswersAll />
                            :
                                menuName === "Video-Setup" ?
                                    <AdminVideoSetup />
                                :
                                    menuName === "ค้นหาผู้ใช้งาน" ?
                                        <AdminUser />
                                    :
                                        menuName === "ผู้ใช้งานทั้งหมด" ?
                                            <AdminUsers />
                                        :
                                            menuName === "แจ้งข่าวสาร" ?
                                                <AdminNews />
                                            :
                                                menuName === "การสมัคร" ?
                                                    <AdminRegisterLogs />
                                                :
                                                    menuName === "การเข้าใช้งาน" ?
                                                        <AdminLoginLogs />
                                                    :
                                                        menuName === "ข้อความถึงแอดมิน" ?
                                                            <AdminMessagesToAdmin />
                                                        :
                                                            menuName === "Test-Agora" ?
                                                                <AdminTestAgora />
                                                            :
                                                                null
                }
                </div>
            </div>
        </div>
    );
}

export default AdminDashboardContent;
